import type { DateTimePickerProps } from "@mui/lab";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { isValid, parse } from "date-fns";
import { useAdapterLocale } from "hooks/useAdapterLocale";

import { StyledDatePicker } from "../StyledDatePicker";
import StyledTextField from "../StyledTextField/StyledTextField";

const iconStyle = {
    ".MuiInputBase-root": {
        maxWidth: "9rem",
        ".MuiSvgIcon-root": {
            width: "18px",
        },
    },
};

interface IDateFieldPicker extends Partial<DateTimePickerProps<any>> {
    onChange: any;
    value: any;
    onFieldBlur?: any;
    open?: boolean;
    /**
     * Trigger action on press enter
     */
    onPressEnter?: (date: Date) => void;
}

const DateFieldPicker = ({ onChange, onFieldBlur, value, open, onPressEnter, ...rest }: IDateFieldPicker) => {
    const adapterLocale = useAdapterLocale();

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={adapterLocale}>
            <StyledDatePicker
                {...rest}
                value={value}
                open={open}
                onChange={onChange}
                renderInput={({ inputProps, ...props }) => (
                    <StyledTextField
                        {...props}
                        inputProps={{
                            ...inputProps,
                        }}
                        onClick={(e) => e.stopPropagation()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                (e.target as HTMLInputElement)?.blur();

                                if (onPressEnter) {
                                    const inputValue = (e.target as HTMLInputElement).value;
                                    const date = parse(inputValue, "dd/MM/yyyy", new Date());

                                    if (isValid(date)) {
                                        onPressEnter(date);
                                    }
                                }
                            }
                        }}
                        onBlur={onFieldBlur}
                        sx={iconStyle}
                    />
                )}
            />
        </LocalizationProvider>
    );
};

export default DateFieldPicker;
